module.exports = __webpack_public_path__ + "static/header-logo-39aaef43f247b3a0402f23d50fdb682f.png";